// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__3RAcG","subtitle":"style_subtitle__XsiZ1"};